<template>
  <van-nav-bar class="navBar" :title="title" left-arrow @click-left="onClickLeft" />
</template>

<script>
export default {
  props: ['title'],
  methods: {
    onClickLeft: () => history.back()
  }
}
</script>

<style lang="scss" scoped>
.navBar {
  height: 20%;
}
</style>
